// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="buildings.UniqueStartingBuilds"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="buildings.TotalStartingBuilds"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;